import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'
import companies from 'modules/core/store/collections/companies'

import AtsCompany from 'modules/ats/store/models/AtsCompany'

class AtsCompanies extends Collection<AtsCompany> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  get cacheKey(): string {
    return 'atsCompanies'
  }

  model() {
    return AtsCompany
  }

  get current(): AtsCompany | null | undefined {
    return this.find({
      company_id: companies.current.attributes.id,
    })
  }
}

const singleton: AtsCompanies = new AtsCompanies()

export default singleton
